import { cn } from '@/utils/tailwind.util';
import { QuizHint } from './QuizHint';
import { QuizSpacingRule } from './QuizSpacingRule';
import { type HintType } from './types';
interface QuizHintGroupProps {
  hint?: {
    type?: string;
    value?: string;
  } | null;
  ignoreSpaces?: boolean | null;
  className?: string;
}

/**
 * QuizHintGroup - 채점 기준·힌트 행 묶음
 * @component
 */
export const QuizHintGroup = ({
  hint,
  ignoreSpaces,
  className
}: QuizHintGroupProps) => {
  const hasSpacingRule = ignoreSpaces === false;
  if (!hasSpacingRule && !hint?.value) return null;
  return <div className={cn('flex flex-col gap-xs', className)} data-sentry-component="QuizHintGroup" data-sentry-source-file="QuizHintGroup.tsx">
      <QuizSpacingRule ignoreSpaces={ignoreSpaces} data-sentry-element="QuizSpacingRule" data-sentry-source-file="QuizHintGroup.tsx" />
      {hint?.value && <QuizHint type={hint.type as HintType} value={hint.value} />}
    </div>;
};